import { useEffect } from 'react';

export function useProgressierRegistration(userId?: string) {
  useEffect(() => {
    if (!userId) return;

    let stopped = false;
    let retries = 0;
    const maxRetries = 20;

    const registerUser = () => {
      if (stopped) return true;
      try {
        const progressier = (window as any).progressier;
        if (!progressier?.add) return false;
        progressier.add({ id: userId });
        console.log('[PROGRESSIER] Registered user:', userId);
        return true;
      } catch (error) {
        console.warn('[PROGRESSIER] Registration failed:', error);
        return false;
      }
    };

    if (registerUser()) return;

    const interval = window.setInterval(() => {
      retries += 1;
      if (registerUser() || retries >= maxRetries) {
        window.clearInterval(interval);
      }
    }, 1500);

    const onVisible = () => {
      if (!document.hidden) registerUser();
    };

    window.addEventListener('focus', onVisible);
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      stopped = true;
      window.clearInterval(interval);
      window.removeEventListener('focus', onVisible);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [userId]);
}
